import { Snackbar } from "@amzn/storm-ui";
import { useIntervalEffect } from "@react-hookz/web";
import { isEmpty } from "lodash";
import React from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { notificationStore } from "../store/notification";

const NotificationsContainer = styled.div<{ hasNotifications: boolean }>`
    z-index: ${(props) => (props.hasNotifications ? () => 701 : 0)};
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: end;
    padding: 30px;
`;

const SnackbarContainer = styled.div`
    width: 100%;
`;

const NotificationSnackBar = styled(Snackbar)`
    margin: 10px;
`;

export const dismissExpiredNotificationsRefreshRateMS = 30000; // 30 seconds;

export const Notifications: React.FunctionComponent = () => {
    const [notifications, dismissNotification, dismissExpiredNotifications] =
        useStore(notificationStore, (state) => [
            state.notifications,
            state.dismissNotification,
            state.dismissExpiredNotifications,
        ]);

    useIntervalEffect(() => {
        if (!isEmpty(notifications)) {
            dismissExpiredNotifications(
                dismissExpiredNotificationsRefreshRateMS,
            );
        }
    }, dismissExpiredNotificationsRefreshRateMS);

    const x = notifications;

    return (
        <NotificationsContainer
            hasNotifications={!isEmpty(notifications)}
            id="insighthub-notifications"
            data-testid="notifications-container"
        >
            <SnackbarContainer>
                {notifications.map(({ type, message, identifier }) => {
                    return (
                        <NotificationSnackBar
                            id={identifier}
                            key={identifier}
                            data-testid={`notification-${identifier}`}
                            variant={type}
                            onClose={() => dismissNotification(identifier)}
                        >
                            {message}
                        </NotificationSnackBar>
                    );
                })}
            </SnackbarContainer>
        </NotificationsContainer>
    );
};

export default Notifications;
